import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { queryGetTemplateList } from "Apollo";
import Suggestion from "./SuggestionWithMutation";
import { hasError } from "apollo-client/core/ObservableQuery";

export default graphql(queryGetTemplateList)(
  observer(
    class TemplateReplySuggestion extends Component {
      static PropTypes = {
        text: PropTypes.string,
        onConfirm: PropTypes.func
      };
      state = {
        loading: false
      };
      render() {
        const { text, textTyping, onConfirm } = this.props;
        const getTemplateList = this.props.data.getTemplateList;
        const list = getTemplateList ? getTemplateList : [];
        const contentList = [];
        list.map(items => {
          let arrOfTemplate = items.templateReply;
          arrOfTemplate.map(template => {
            contentList.push(template);
          });
        });

        var contentFilter = [];
        if (textTyping.length > 0) {
          let textTypingSplit = textTyping.split(" ");
          textTypingSplit.map(text => {
            contentFilter = contentList.filter(function(item) {
              return item.content.toUpperCase().includes(text.toUpperCase());
            });
          });
          if (contentFilter.length > 5) {
            contentFilter = contentFilter.splice(0, 5);
          }
          var rendersSuggestion = (
            <Suggestion
              contentList={contentFilter}
              textTypingSplit={textTypingSplit[textTypingSplit.length - 1]}
            />
          );
        }
        return <Wrapper>{rendersSuggestion}</Wrapper>;
      }
    }
  )
);

const TemplateReplySuggest = styled.div`
  min-height: 20px;
  border-radius: 20px;
  border: 1px solid #a5a5a5;
  margin: 0px 3px 0px 3px;
  padding: 5px 10px 5px 10px;
  background: white;
`;

const TemplateReplyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 6px;
  background-color: transparent;
`;

const Wrapper = styled.div``;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/TemplateReplySuggestion.js